import type { FaireProductEntity } from "../../entity_types/product";

export const p_qtp8z4httd: FaireProductEntity = {
  token: "p_qtp8z4httd",
  type: "product",
  name: "18K gold-plated PVD stainless steel zirconia bead necklace",
  brandToken: "b_3t5pew5dxb",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/709681e50524d6735e68c1c4b03f643454cc555370c8ee5d35070b271e378597.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/9aaf487a47f4db43ed92e45c449497b88601608cedf8d1213b45fc2747584108.jpeg",
    "https://cdn.faire.com/fastly/758bfa6e20c4d1c9c4fdb559c1147031a33e0553d7602c35aa678e79db318861.jpeg",
    "https://cdn.faire.com/fastly/2939a278dee4ee10791952773b29721c285b8fd328718c5034e0f68723c33de3.jpeg",
    "https://cdn.faire.com/fastly/c0ea2dca23fb2ea1b47121df32f34e67050ee2183fc5140d90cc7f3e8c2433c3.jpeg",
    "https://cdn.faire.com/fastly/605aa7fdfbd46280b34f1fac8defeaa2a285d52a65bc960fde7aceda6748602f.jpeg",
    "https://cdn.faire.com/fastly/ebc72bb33080a9819c479b4a9ef5a3aba5004b27f97e6ef4b5fa9cae2aa9b324.jpeg",
    "https://cdn.faire.com/fastly/2d518e2f0ae203fc3cc675c7ec3261da4acc2e2f7c9986d195d47abdd3b146d5.png",
  ],
  priceDollars: 10.38,
  description:
    "Premium quality necklace with colored cubic zirconia pendants, stainless steel beaded chain\n\nPremium Material: Stainless steel with 18K vacuum gold plating (PVD Waterproof); water-resistant, durable and does not fade.\nFinish: High-gloss polish with colored cubic zirconia (pink, white, lilac, blue, and multicolor)\nLength: Approximately 40 cm plus about 5 cm adjustable extension\n\nStock in Spain: Fast shipping and no customs.\n\nDirect Price: Luxury look at factory price.",
  tags: [],
  msrpDollars: 20.76,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:22.172Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
